import { ProductDraft, AddonsList } from '@helpers/Models';

/**
 * Converts a product draft object from the UI state
 * into the structured format required for storage/API submission.
 *
 * Transformations performed:
 * - Converts quantity and fat percentage to numbers.
 * - Extracts addon IDs from addon objects or numeric values.
 * - Maps package data into { productPackageTypeId, percentage } format.
 * - Ensures packaging notes are always a string.
 *
 * @param product - The product draft object from the UI state.
 * @returns Formatted product object ready for storage.
 */
export const ConvertToStorageFormat = (product: ProductDraft) => ({
  productId: product.productId,
  quantity: Number(product.quantity),
  fatPercent: Number(product.fatPercentage),
  addOnIds:
    product.addons?.map((a) =>
      typeof a === 'object' && a !== null
        ? ((a as AddonsList).id ?? 0)
        : Number(a),
    ) ?? [],
  packaging:
    product.packages?.map((pkg: any) => ({
      productPackageTypeId: pkg.id,
      percentage: pkg.percentage,
    })) ?? [],
  packagingNotes: product.notes ?? '',
});
